/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DatabaseCategoryFieldOption
 */
export interface DatabaseCategoryFieldOption {
    /**
     * 
     * @type {string}
     * @memberof DatabaseCategoryFieldOption
     */
    value?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseCategoryFieldOption
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseCategoryFieldOption
     */
    wert?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseCategoryFieldOption
     */
    icon?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseCategoryFieldOption
     */
    dependingValue?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseCategoryFieldOption
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseCategoryFieldOption
     */
    textColor?: string;
    /**
     * Fertigstellungsgrad in PROZENT (0..100), den ein Datensatz mit dieser Ausprägung erreicht hat. Grundlage der Ansicht „Fortschritt" im Board: erbracht = Summe (Anzahl je Phase x Grad).
     * WARUM NICHT `wert`: Dort steht an genau denselben Feldern bereits die 0/1-Kennzeichnung der Vorbelegung (welche Spalten beim Oeffnen angehakt sind). Beides in eine Zahl zu legen hiesse, dass die eine Einstellung die andere lautlos abschaltet -- `hatVorbelegung` verlangt, dass ALLE Ausprägungen 0 oder 1 tragen.
     * WER IHN SETZT: die Vorlage. Ein Fertigstellungsgrad ist eine Setzung, keine Ableitung -- aus „Review" folgt nicht von selbst, ob das 60 oder 75 Prozent sind. Die Vorlage bringt die Zahlen mit; aendern muss sie niemand.
     * @type {number}
     * @memberof DatabaseCategoryFieldOption
     */
    fortschritt?: number;
    /**
     * Erklaerung zu DIESER Option, als Info-Zeichen neben ihr sichtbar.
     * WOFUER: Bei Werten wie "Backlog", "Planung" oder "Sprint" steht die eigentliche Auskunft nicht im Wort, sondern in der Frage, WAS an dieser Stelle passiert und WER etwas tut. Bisher liess sich das nirgends hinterlegen -- die Erklaerung stand im Handbuch, also genau dort nicht, wo man waehlt.
     * BEWUSST AN DER OPTION UND NICHT IM BAUTEIL: Ein Hinweis, der an einem bestimmten Wortlaut haengt, waere beim ersten Umbenennen falsch und liesse sich fuer eigene Werte gar nicht vergeben.
     * @type {string}
     * @memberof DatabaseCategoryFieldOption
     */
    hinweis?: string;
}

/**
 * Check if a given object implements the DatabaseCategoryFieldOption interface.
 */
export function instanceOfDatabaseCategoryFieldOption(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseCategoryFieldOptionFromJSON(json: any): DatabaseCategoryFieldOption {
    return DatabaseCategoryFieldOptionFromJSONTyped(json, false);
}

export function DatabaseCategoryFieldOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseCategoryFieldOption {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': !exists(json, 'value') ? undefined : json['value'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'wert': !exists(json, 'wert') ? undefined : json['wert'],
        'icon': !exists(json, 'icon') ? undefined : json['icon'],
        'dependingValue': !exists(json, 'dependingValue') ? undefined : json['dependingValue'],
        'color': !exists(json, 'color') ? undefined : json['color'],
        'textColor': !exists(json, 'textColor') ? undefined : json['textColor'],
        'fortschritt': !exists(json, 'fortschritt') ? undefined : json['fortschritt'],
        'hinweis': !exists(json, 'hinweis') ? undefined : json['hinweis'],
    };
}

export function DatabaseCategoryFieldOptionToJSON(value?: DatabaseCategoryFieldOption | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
        'label': value.label,
        'wert': value.wert,
        'icon': value.icon,
        'dependingValue': value.dependingValue,
        'color': value.color,
        'textColor': value.textColor,
        'fortschritt': value.fortschritt,
        'hinweis': value.hinweis,
    };
}

